export default __webpack_public_path__ + "static/media/sos-dia-11-11.32562ed5.webp";